import CurrentPlanButton from '../../components/CurrentPlanButton';
import SignupButton from '../../components/common/SignupButton';
import { jsx as _jsx } from "react/jsx-runtime";
export const FreeToolsPurchaseMotion = ({
  trackingSource,
  sourceId = 'pricing-hero',
  productLine = 'crm',
  isInApp = false
}) => {
  return isInApp ? /*#__PURE__*/_jsx(CurrentPlanButton, {
    visible: true
  }) : /*#__PURE__*/_jsx(SignupButton, {
    sourceId: sourceId,
    productLine: productLine,
    use: "primary",
    trackingSource: trackingSource
  });
};